import { PayloadAction } from '@reduxjs/toolkit';

import { HostSettingsState } from 'editor/src/store/hostSettings/types';

const setHostSettingsReducer = (state: HostSettingsState, action: PayloadAction<Partial<HostSettingsState>>) => {
  Object.assign(state, action.payload);
};

export default setHostSettingsReducer;
